import React, { useState } from 'react';
import Modal from '../components/Modal';

const ModalTest = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <div style={{ padding: '20px' }}>
      <h1>Teste de Modal</h1>
      <button 
        onClick={() => {
          console.log('Botão clicado, abrindo modal');
          setShowModal(true);
        }}
        style={{
          padding: '10px 20px',
          backgroundColor: '#3b82f6',
          color: 'white',
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer'
        }}
      >
        Abrir Modal
      </button>
      
      <p>Estado do modal: {showModal ? 'ABERTO' : 'FECHADO'}</p>
      
      <Modal
        isOpen={showModal}
        onClose={() => {
          console.log('Fechando modal');
          setShowModal(false);
        }}
        title="Modal de Teste"
        size="md"
      >
        <div style={{ padding: '20px' }}>
          <h2>Modal está funcionando!</h2>
          <p>Se você consegue ver esta mensagem, o modal está sendo exibido corretamente.</p>
          <button 
            onClick={() => setShowModal(false)}
            style={{
              padding: '8px 16px',
              backgroundColor: '#ef4444',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              marginTop: '10px'
            }}
          >
            Fechar Modal
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default ModalTest;